import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { useAuth } from "../context/AuthContext"; // Import from AuthContext
import "./AddClients.css";

function AddClients() {
  const { currentUser, role } = useAuth();

  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState("");
  const [clientType, setClientType] = useState("High School");
  const [address, setAddress] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [contact1, setContact1] = useState("");
  const [contact1Title, setContact1Title] = useState("");
  const [contact1Phone, setContact1Phone] = useState("");
  const [contact1Email, setContact1Email] = useState("");
  const [contact2, setContact2] = useState("");
  const [contact2Title, setContact2Title] = useState("");
  const [contact2Phone, setContact2Phone] = useState("");
  const [contact2Email, setContact2Email] = useState("");
  const [schoolComps, setSchoolComps] = useState("");
  const [coachComps, setCoachComps] = useState("");
  const [notes, setNotes] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [dropbox, setDropbox] = useState("");
  const [clientID, setClientID] = useState("");
  const [bellNotes, setBellNotes] = useState("");
  const [defaultContact, setDefaultContact] = useState("");

  // Check if the currentUser is an admin
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (currentUser) {
        const usersRef = collection(db, "users");
        const querySnapshot = await getDocs(usersRef);
        querySnapshot.forEach((doc) => {
          if (doc.id === currentUser.uid && doc.data().role === "admin") {
            setIsAdmin(true);
          }
        });
      }
    };
    checkAdminStatus();
  }, [currentUser]);

  // Fetch existing clients (if needed)
  useEffect(() => {
    const fetchClients = async () => {
      const clientsRef = collection(db, "clients");
      const querySnapshot = await getDocs(clientsRef);
      setClients(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchClients();
  }, []);

  // Handle adding a new client
  const handleAddClient = async (e) => {
    e.preventDefault();
    if (!clientName.trim()) {
      alert("Client Name is required!");
      return;
    }

    try {
      const clientsRef = collection(db, "clients");
      await addDoc(clientsRef, {
        name: clientName,
        clientType,
        address,
        shippingAddress, // Field is added here
        contact1,
        contact1Title,
        contact1Phone,
        contact1Email,
        contact2,
        contact2Title,
        contact2Phone,
        contact2Email,
        schoolComps,
        coachComps,
        notes,
        clientID,
        bellNotes,
        defaultContact,
        dropbox: dropbox.trim() || ""

      });

      alert("Client added successfully!");
      // Clear the form
      setClientName("");
      setClientType("High School");
      setAddress("");
      setShippingAddress("");
      setContact1("");
      setContact1Title("");
      setContact1Phone("");
      setContact1Email("");
      setContact2("");
      setContact2Title("");
      setContact2Phone("");
      setContact2Email("");
      setSchoolComps("");
      setCoachComps("");
      setNotes("");
      setDropbox(""); // Clear dropbox field
      setClientID("");
      setBellNotes("");
      setDefaultContact("");
    } catch (error) {
      console.error("Error adding client:", error);
      alert("Failed to add client.");
    }
  };

  return (
    <div className="add-clients-container">
      <h2>Add Clients</h2>
      <form onSubmit={handleAddClient} className="client-form">
       
        {/* Basic Information */}
        <div className="form-section">
          <label>Name:</label>
          <input
            type="text"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          />

          <label>Client Type:</label>
          <select
            value={clientType}
            onChange={(e) => setClientType(e.target.value)}
          >
            <option value="High School">High School</option>
            <option value="Middle School">Middle School</option>
            <option value="Baseball/Softball Club">Baseball/Softball Club</option>
            <option value="Dance/Gymnastics Club">Dance/Gymnastics Club</option>
            <option value="Event">Event</option>
            <option value="Football/Cheer Club">Football/Cheer Club - Regular pricing</option>
            <option value="Headshots/Corporate">Headshots/Corporate</option>
            <option value="Hockey/Figure Skating">Hockey/Figure Skating</option>
            <option value="League">League Large - Youth Pricing</option>
            <option value="Miscellaneous">Miscellaneous</option>
            <option value="Swim Club">Swim/Tennis Club</option>
            <option value="Travel Team (Small Single Team)">Travel Team (Small Single Team)</option>
            <option value="Volleyball Club">Volleyball Club</option>
            <option value="Wrestling Club">Wrestling Club</option>
          </select>

          <label>Shooting Location Address:</label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />

          <label>Shipping Address:</label>
          <input
            type="text"
            value={shippingAddress}
            onChange={(e) => setShippingAddress(e.target.value)}
          />

          <label>Client ID:</label>
          <input
            type="text"
            value={clientID}
            onChange={(e) => setClientID(e.target.value)}
          />

          <label>Final Bell:</label>
          <input
            type="text"
            value={bellNotes}
            onChange={(e) => setBellNotes(e.target.value)}
          />

          <label>Default Contact:</label>     
          <input                           
            type="text"                  
            value={defaultContact}          
            onChange={(e) => setDefaultContact(e.target.value)}  
          />                               


        </div>

        {/* Contact Information Sections */}
        <div className="form-section">
          <h3>Primary Contact</h3>
          <label>Name:</label>
          <input
            type="text"
            value={contact1}
            onChange={(e) => setContact1(e.target.value)}
          />
          <label>Title:</label>
          <input
            type="text"
            value={contact1Title}
            onChange={(e) => setContact1Title(e.target.value)}
          />
          <label>Phone:</label>
          <input
            type="text"
            value={contact1Phone}
            onChange={(e) => setContact1Phone(e.target.value)}
          />
          <label>Email:</label>
          <input
            type="email"
            value={contact1Email}
            onChange={(e) => setContact1Email(e.target.value)}
          />
        </div>

        <div className="form-section">
          <h3>Secondary Contact</h3>
          <label>Name:</label>
          <input
            type="text"
            value={contact2}
            onChange={(e) => setContact2(e.target.value)}
          />
          <label>Title:</label>
          <input
            type="text"
            value={contact2Title}
            onChange={(e) => setContact2Title(e.target.value)}
          />
          <label>Phone:</label>
          <input
            type="text"
            value={contact2Phone}
            onChange={(e) => setContact2Phone(e.target.value)}
          />
          <label>Email:</label>
          <input
            type="email"
            value={contact2Email}
            onChange={(e) => setContact2Email(e.target.value)}
          />
        </div>

        <div className="form-section">
          <label>School Comps:</label>
          <input
            type="text"
            value={schoolComps}
            onChange={(e) => setSchoolComps(e.target.value)}
          />

          <label>Coach Comps:</label>
          <input
            type="text"
            value={coachComps}
            onChange={(e) => setCoachComps(e.target.value)}
          />

          <label>Notes:</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
      
      <label htmlFor="dropbox">Dropbox Link</label>
<input 
  type="url" 
  id="dropbox" 
  placeholder="Enter dropbox URL" 
  value={dropbox}
  onChange={(e) => setDropbox(e.target.value)}
/>



        </div>

        <button type="submit" className="submit-button">Add Client</button>
      </form>
    </div>
  );
}

export default AddClients;
